var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7364 7.13647C11.2193 7.13708 10.7065 7.23012 10.2222 7.4112L15.8445 13.0334C16.0279 12.5431 16.121 12.0236 16.1192 11.5001C16.1141 10.341 15.6501 9.23117 14.8287 8.41338C14.0073 7.59559 12.8955 7.13646 11.7364 7.13647Z",
    fill: "#5A5C66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9075 11.1997C19.7545 7.2194 15.9786 4.81079 11.8003 4.81079C10.6627 4.81346 9.53266 4.99676 8.45251 5.35385L9.48113 6.38885C10.2388 6.19305 11.0178 6.09218 11.8003 6.08857C15.3972 6.08857 18.6683 8.09468 20.617 11.4744C19.9021 12.7283 18.9545 13.8342 17.825 14.7327L18.7322 15.64C20.0395 14.5854 21.1251 13.2826 21.9267 11.8066L22.0928 11.5L21.9075 11.1997Z",
    fill: "#5A5C66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1114 3.69267L5.96085 6.54211C4.15977 7.70177 2.68776 9.3058 1.68668 11.1996L1.52057 11.4999L1.68668 11.8066C3.83974 15.7868 7.61557 18.1954 11.7939 18.1954C13.4248 18.1951 15.0344 17.826 16.5025 17.1157L19.697 20.3102L20.815 19.3518L4.2039 2.74072L3.1114 3.69267ZM8.41418 8.99544C7.81646 9.8384 7.5363 10.8657 7.62331 11.8954C7.71032 12.925 8.15888 13.8907 8.88958 14.6214C9.62028 15.3521 10.586 15.8007 11.6157 15.8877C12.6454 15.9747 13.6726 15.6946 14.5156 15.0968L15.5378 16.1191C14.3544 16.6249 13.0808 16.8857 11.7939 16.8857C8.19696 16.8857 4.92585 14.8796 2.97724 11.4999C3.91238 9.84403 5.25917 8.45763 6.88724 7.47489L8.41418 8.99544Z",
    fill: "#5A5C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.7b54a907e411da786467a908c433bde6.svg";
export { ForwardRef as ReactComponent };